import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  supportedSizesList: {
    marginTop: 8,
    paddingLeft: 0,
    listStyle: 'none'
  },
  sizeItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 4
  }
})

export default useStyles
